import { Component, ElementRef, Input, OnDestroy, OnInit, PLATFORM_ID, ViewChild, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-youtube-video',
  imports: [],
  templateUrl: './youtube-video.component.html',
  styleUrl: './youtube-video.component.scss'
})
export class YoutubeVideoComponent implements OnInit, OnDestroy {

  activeModal = inject(NgbActiveModal);
  private sanitizer = inject(DomSanitizer);
  private platformId = inject(PLATFORM_ID);

  @Input() videoId!: string;
  @Input() videoTitle: string = 'Video';

  @ViewChild('player') player?: ElementRef<HTMLIFrameElement>;

  videoUrl!: SafeResourceUrl;

  private readonly onPlayerMessage = (event: MessageEvent) => {
    if (typeof event.data !== 'string' || !event.origin.includes('youtube')) return;
    try {
      const message = JSON.parse(event.data);
      // playerState 0 = ended
      const state = message?.event === 'onStateChange' ? message.info : message?.info?.playerState;
      if (state === 0) this.activeModal.close();
    } catch { }
  };

  ngOnInit(): void {
    const origin = isPlatformBrowser(this.platformId) ? `&origin=${window.location.origin}` : '';
    this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://www.youtube-nocookie.com/embed/${this.videoId}?autoplay=1&rel=0&playsinline=1&enablejsapi=1${origin}`
    );
    if (isPlatformBrowser(this.platformId))
      window.addEventListener('message', this.onPlayerMessage);
  }

  onPlayerLoad(): void {
    // Handshake required for the YouTube widget to start posting state updates (used to auto-close on end)
    this.player?.nativeElement.contentWindow?.postMessage(
      JSON.stringify({ event: 'listening', id: 'ytplayer', channel: 'widget' }),
      'https://www.youtube-nocookie.com'
    );
  }

  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId))
      window.removeEventListener('message', this.onPlayerMessage);
  }
}
